import { initReactI18next } from "react-i18next";
import eng from "./trans/eng.json";
import ua from "./trans/ua.json";

import i18n from "i18next";

// New key on purpose: the old "language" key was force-set to "eng" for every visitor
const LANGUAGE_STORAGE_KEY = "lang";
const SUPPORTED_LANGUAGES = ["ua", "eng"];
const HTML_LANG = { ua: "uk", eng: "en" };

const readStoredLanguage = () => {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return SUPPORTED_LANGUAGES.includes(stored) ? stored : null;
  } catch {
    return null;
  }
};

const resources = {
  eng: {
    translation: eng,
  },
  ua: {
    translation: ua,
  },
};

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = HTML_LANG[lng] || lng;
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  } catch {}
});

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: readStoredLanguage() || "ua",
    fallbackLng: "eng",
  });

export default i18n;
